import { render, staticRenderFns } from "./AlopRate.vue?vue&type=template&id=57dc1a32&scoped=true&"
import script from "./AlopRate.vue?vue&type=script&lang=js&"
export * from "./AlopRate.vue?vue&type=script&lang=js&"
import style0 from "./AlopRate.vue?vue&type=style&index=0&id=57dc1a32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc1a32",
  null
  
)

export default component.exports